export default __webpack_public_path__ + "static/waxringwithdifferentmeaurements-2aeb79abd7335e02211a52230cc17349.png";